export default __webpack_public_path__ + "static/media/turbine_open.d9d1a201.png";